import InfoTooltip from "newui/components/InfoTooltip";
import { FormLabel } from "../FormLabel";

interface LabelWithGuidelineProps {
	guideLine?: string;
	htmlFor?: string;
	isGuideLineLink?: boolean;
	label?: string;
	required?: boolean;
	onGuideLineClick?: () => void;
}

export const LabelWithGuideline = ({ guideLine, isGuideLineLink, label, htmlFor, required, onGuideLineClick }: LabelWithGuidelineProps) => {

	if (!label) {
		return null;
	}

	return <FormLabel
		htmlFor={htmlFor}
		label={label}
		required={required}
	>
		{guideLine && isGuideLineLink ? (
			onGuideLineClick ? (
				<button
					type="button"
					onClick={onGuideLineClick}
					className="cursor-pointer"
				>
					<InfoTooltip
						tooltipText={guideLine}
					/>
				</button>
			) : (
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={guideLine}
				>
					<InfoTooltip
						tooltipText={guideLine}
					/>
				</a>
			)
		) : guideLine && (
			<div className="inline-block">
				<InfoTooltip tooltipText={guideLine} />
			</div>
		)}
	</FormLabel>;
}